// Shared category metadata & color mapping
import { getRegion } from "./region";

export const BILL_CATEGORIES = [
  { key: "utilities", label: "Utilities", color: "#10B981" },
  { key: "credit_card", label: "Credit Card", color: "#EF4444" },
  { key: "loan", label: "Loan", color: "#F59E0B" },
  { key: "subscription", label: "Subscription", color: "#8B5CF6" },
  { key: "rent", label: "Rent / Mortgage", color: "#3B82F6" },
  { key: "insurance", label: "Insurance", color: "#06B6D4" },
  { key: "medical", label: "Medical", color: "#EC4899" },
  { key: "other", label: "Other", color: "#64748B" },
];

export const DEBT_CATEGORIES = [
  { key: "credit_card", label: "Credit Card", color: "#EF4444" },
  { key: "loan", label: "Personal Loan", color: "#F59E0B" },
  { key: "medical", label: "Medical", color: "#EC4899" },
  { key: "student", label: "Student Loan", color: "#8B5CF6" },
  { key: "auto", label: "Auto Loan", color: "#06B6D4" },
  { key: "mortgage", label: "Mortgage", color: "#3B82F6" },
  { key: "other", label: "Other", color: "#64748B" },
];

export const RECURRENCE = [
  { key: "none", label: "One-time" },
  { key: "weekly", label: "Weekly" },
  { key: "monthly", label: "Monthly" },
  { key: "yearly", label: "Yearly" },
];

export const catColor = (list, key) => (list.find(c => c.key === key) || list[list.length - 1]).color;
export const catLabel = (list, key) => (list.find(c => c.key === key) || list[list.length - 1]).label;

export const fmt = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: getRegion().currency, maximumFractionDigits: 2 }).format(n || 0);

// Parse date-only strings (YYYY-MM-DD) as LOCAL midnight so they never display a day early.
export const parseLocalDate = (iso) => {
  if (iso instanceof Date) return iso;
  const m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  return new Date(iso);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = parseLocalDate(iso);
  if (isNaN(d.getTime())) return "—";
  const y = d.getFullYear(), mo = d.getMonth() + 1, day = d.getDate();
  const p2 = (x) => String(x).padStart(2, "0");
  switch (getRegion().dateFormat) {
    case "long": return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
    case "us": return `${p2(mo)}/${p2(day)}/${y}`;
    case "eu": return `${p2(day)}/${p2(mo)}/${y}`;
    case "iso": return `${y}-${p2(mo)}-${p2(day)}`;
    default: return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  }
};
export const weekdayShort = (iso) => parseLocalDate(iso).toLocaleDateString("en-US", { weekday: "short" });

export function downloadCSV(filename, rows) {
  if (!rows || !rows.length) return;
  const headers = Object.keys(rows[0]);
  const csv = [headers.join(","), ...rows.map(r => headers.map(h => {
    const v = r[h] ?? "";
    const s = String(v).replace(/"/g, '""');
    return /[,"\n]/.test(s) ? `"${s}"` : s;
  }).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
